<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end detail-mode"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm">
          Save
        </button>
      </div>
    </div>

    <!-- Card Page -->
    <div class="card-page card-page-detail">
      <!-- Card Title -->
      <div class="card-page-title-multiple">
        <div class="d-flex align-items-start">
          <!-- Back icon -->
          <img
            src="@/assets/new-form-ui/arrow-icon.svg"
            class="back-icon"
          >

          <!-- Title -->
          <div class="w-100">
            <div
              :class="{'error-input' : $v.dataSetup.text_1.$error}"
              class="title-1"
              @click="openModalTitle('text_1')"
            >
              {{ dataSetup.text_1 || 'Field 1' }}

              <!-- Edit -->
              <div
                class="edit-or-delete"
                @click.stop="openModalTitle('text_1')"
              >
                <div class="button">
                  <div
                    class="edit"
                    @click.stop="openModalTitle('text_1')"
                  >
                    <i class="fa fa-pencil-square-o" />
                    <div class="tooltip-component">Edit title</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="{'error-input' : $v.dataSetup.text_2.$error}"
              class="title-2"
              @click="openModalTitle('text_2')"
            >
              {{ dataSetup.text_2 || 'Field 2' }}

              <!-- Edit -->
              <div
                class="edit-or-delete"
                @click.stop="openModalTitle('text_2')"
              >
                <div class="button">
                  <div
                    class="edit"
                    @click.stop="openModalTitle('text_2')"
                  >
                    <i class="fa fa-pencil-square-o" />
                    <div class="tooltip-component">Edit variable</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab -->
            <div class="wrap-tabs">
              <div class="tabs">
                <div
                  v-for="(tab, index) in tabs"
                  :key="tab.id"
                  :class="{ 'active': tab.id === tabSelected.id }"
                  class="tab"
                  @click="changeTab(tab, index)"
                >
                  {{ tab.title }}

                  <!-- Edit or Delete -->
                  <div class="edit-or-delete">
                    <div class="button">
                      <!-- Edit -->
                      <div
                        class="edit"
                        @click.stop="openModalTab(tab, index)"
                      >
                        <i class="fa fa-pencil-square-o" />
                      </div>
                      <!-- Delete -->
                      <div
                        class="delete"
                        @click.stop="deleteTab(index)"
                      >
                        <i class="fa fa-trash" />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="add-tab"
                  @click="openModalTab(null, null)"
                >
                  <div class="add-icon">
                    <i class="fa fa-plus"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Content -->
      <div class="card-page-content multiple">
        <!-- If loading -->
        <j-skeleton-component v-if="isLoading" />

        <!-- Component if not loading -->
        <section
          v-if="!isLoading && tabs.length > 0 && tabIndexSelected !== null"
          :class="{'have-data': tabs[tabIndexSelected].component && tabs[tabIndexSelected].component.length > 0}"
          class="section-field section-field-component mb-5"
        >
          <!-- If not have component -->
          <h5 v-if="tabSelected.component.length === 0">No component on this view</h5>

          <!-- List Component -->
          <draggable
            v-model="tabs[tabIndexSelected].component"
            :options="{
              animation:300,
            }"
            group="fieldsLibrary"
            @change="modifyData"
          >
            <div
              v-for="(component, index) in tabs[tabIndexSelected].component"
              :key="`${component.name}-${index}`"
              :class="{ 'selected': selectedIndexComponent === index && isOpenPropertiesComp }"
              class="component-list"
            >
              <!-- Dummy Table View -->
              <dummy-table-view
                v-if="component.info && JSON.parse(component.info).default_view === 'table_view'"
                :data-component="component"
                :for-detail-parent="true"
              />

              <!-- Dummy Table Requestor View -->
              <dummy-table-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'table_requester_view'"
                :data-component="component"
                :type="'requestor'"
                :for-detail-parent="true"
              />

              <!-- Dummy Table Approver View -->
              <dummy-table-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'table_approver_view'"
                :data-component="component"
                :type="'approver'"
                :for-detail-parent="true"
              />

              <!-- Dummy Create View -->
              <dummy-create-detail-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'create_view'"
                :data-component="component"
                :type="'create'"
                :for-detail-parent="true"
              />

              <!-- Dummy Detail View -->
              <dummy-create-detail-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'detail_view'"
                :data-component="component"
                :type="'detail'"
                :for-detail-parent="true"
              />

              <!-- Dummy Calendar View -->
              <dummy-calendar-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'calendar_view'"
                :data-component="component"
                :for-detail-parent="true"
              />

              <!-- Dummy Export View -->
              <dummy-export-view
                v-else-if="component.info && JSON.parse(component.info).default_view === 'export_view'"
                :data-component="component"
                :for-detail-parent="true"
              />

              <!-- If component has not configuration -->
              <div
                v-else
                class="skeleton-component"
              />

              <!-- Edit or Delete -->
              <div
                v-if="component.info"
                class="edit-or-delete">
                <div class="button">
                  <!-- New tab -->
                  <div
                    class="new-tab"
                    @click="onOpenNewtab(component)"
                  >
                    <i class="fa fa-external-link" />
                    <div class="tooltip-component">Open new tab</div>
                  </div>

                  <!-- Edit -->
                  <div
                    class="edit"
                    @click="openConfigurationComponent(component, index)"
                  >
                    <i class="fa fa-pencil-square-o" />
                    <div class="tooltip-component">Edit component</div>
                  </div>
                  <!-- Delete -->
                  <div
                    class="delete"
                    @click="deleteComponent(index)"
                  >
                    <i class="fa fa-trash" />
                    <div class="tooltip-component">Delete component</div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>

          <!-- Add new field -->
          <div
            class="btn-add-more"
            @click="openModalFieldLibrary(false)"
          >
            <img
              :src="require('@/assets/icon/add.png')"
              class="m__r--5"
              height="15"
              width="15"
            >
            Add Component
          </div>
        </section>

        <!-- Config Button -->
        <section>
          <h5>Button</h5>

          <native-buttons
            :data-buttons="nativeButtons"
            :is-workflow="isWorkflow"
            :is-multiple="isMultipleForm"
            :is-dynamic-workflow="isDynamicWorkflow"
            :is-approver-selection-by-function="isApproverSelectionByFunction"
            :is-page-screen="true"
            :button-active="modeBtn"
            menu="detail"
            @select-btn="openConfigNativeButton"
          />
        </section>
      </div>
    </div>

    <!-- Delete View -->
    <div class="card-transparent card-transparent-detail m__t--15">
      <span
        v-if="formDetail.detail_view || (formDetail.tabs && formDetail.tabs.length > 0)"
        class="cursor-pointer"
        style="font-size: 14px"
        @click="deleteView"
      >
        <i class="fa fa-trash"/> <small>Delete this view</small>
      </span>
    </div>

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Modal Title -->
    <modal-title-multiple-detail
      v-if="isOpenModalTitle"
      :id="idModalTitle"
      :data="selectedTitle"
      :options="variableOptions"
      :title="selectedTypeTitle === 'text_1' ? 'Field 1' : 'Field 2'"
      @close-modal="toggleModalTitle(false)"
      @submit="submitModalTitle"
    />

    <!-- Modal Tab -->
    <modal-setup-tab
      v-if="isOpenModalTab"
      :id="idModalTab"
      :data="selectedTab"
      @delete-tab="deleteTab"
      @close-modal="toggleModalTab(false)"
      @submit="submitModalTab"
    />

    <component-configuration
      v-if="isOpenPropertiesComp"
      :id="idPropertiesComp"
      :field-detail="selectedComponent"
      :options="variableOptions"
      @submit-mode="submitComponent"
      @delete-configuration="deleteComponent"
      @close-configuration="toggleConfigurationComponent(false)"
    />

    <!-- Configuration Native Button -->
    <native-button-configuration
      v-if="isOpenConfigNativeBtn"
      :id="idConfigNativeBtn"
      :field-detail="selectedNativeBtn"
      :is-revision-btn="isRevisionBtn"
      :data-revision="nativeButtons.revision"
      :label="labelBtn"
      :mode="modeBtn"
      @close-configuration="toggleConfigurationNativeBtn(false)"
      @submit-configuration="submitNativeButton"
    />

    <!-- Modal Script Before & After -->
    <b-modal
      ref="modalScriptBeforeAfter"
      :hide-header="true"
      :hide-footer="true"
      class="modal-native-action-button"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-script-before-after-field
        v-if="showModalScriptBeforeAfter"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';
// Mixins
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixSetupNativeButton from '@/mixins/form-ui-v2/jMixSetupNativeButton';
// Components
import draggable from 'vuedraggable';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import NativeButtons from '@/views/experience-manager-v2/partials/NativeButtons';
import NativeButtonConfiguration from '@/views/experience-manager-v2/partials//configuration/NativeButtonConfiguration';
import ModalTitleMultipleDetail from '@/views/experience-manager-v2/popup/ModalTitleMultipleDetail';
import ComponentConfiguration from '@/views/experience-manager-v2/partials/configuration/ComponentConfiguration';
import ModalSetupTab from '@/views/experience-manager-v2/popup/ModalSetupTab';
import ModalScriptBeforeAfterField from '@/views/experience-manager-v2/popup/ModalScriptBeforeAfterField';
// Dummy Component
import DummyTableView from '@/components/dummy/DummyTableView';
import DummyCreateDetailView from '@/components/dummy/DummyCreateDetailView';
import DummyCalendarView from '@/components/dummy/DummyCalendarView';
import DummyExportView from '@/components/dummy/DummyExportView';
// Skeleton
import jSkeletonComponent from '@/views/experience-manager-v2/loading/jSkeletonComponent';

export default {
  validations: {
    dataSetup: {
      text_1: { required },
      text_2: { required },
    },
  },

  components: {
    draggable,
    ModalFieldLibrary,
    NativeButtons,
    NativeButtonConfiguration,
    ModalTitleMultipleDetail,
    ComponentConfiguration,
    ModalSetupTab,
    ModalScriptBeforeAfterField,
    DummyTableView,
    DummyCreateDetailView,
    DummyCalendarView,
    DummyExportView,
    jSkeletonComponent,
  },

  mixins: [jMixScroll, jMixToolbox, jMixSetupNativeButton],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        title: null,
        text_1: null,
        text_2: null,
      },
      tabs: [],
      tabSelected: [],
      tabIndexSelected: null,
      dataComponent: [],
      variableOptions: [],
      isError: false,

      // modal title
      idModalTitle: 'modalTitle',
      isOpenModalTitle: false,
      selectedTitle: null,
      selectedTypeTitle: null,

      // Modal tab
      idModalTab: 'modalTab',
      isOpenModalTab: false,
      selectedTab: null,
      selectedIndexTab: null,

      // Properties Component
      idPropertiesComp: 'propertiesComponent',
      isOpenPropertiesComp: false,
      selectedComponent: null,
      selectedIndexComponent: null,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
    ...mapState('jStoreApplication', ['list_component_master']),
    ...mapState('jStoreExperienceManagerV2', ['showModalFieldLibrary']),

    genData() {
      const params = this._.cloneDeep(this.formDetail);

      // Generate Detail View
      params.detail_view = this.dataSetup;

      // Generate Tab
      params.tabs = this.tabs;

      // Generate Native Button
      params.native_buttons = {
        approve: this.nativeButtons.approve,
        create: this.nativeButtons.create,
        delete: this.nativeButtons.delete,
        reject: this.nativeButtons.reject,
        update: this.nativeButtons.update,
        draft: this.nativeButtons.draft,
        submit: this.nativeButtons.submit,
        close: this.nativeButtons.close,
        cancel: this.nativeButtons.cancel,
        need_revision: this.nativeButtons.revision,
        approve_update: this.nativeButtons.approveUpdate,
      };

      return params;
    },

    isWorkflow() {
      return this.formData ? this.formData.is_use_workflow : false;
    },

    isDynamicWorkflow() {
      return this.form_data_detail.length > 0 ?
        (!!(this.form_data_detail[0].workflow && this.form_data_detail[0].workflow.type === 'dynamic')) : false;
    },
    isApproverSelectionByFunction() {
      return this.formData ?
        (!!(this.formData.workflow && this.formData.workflow.approver_selection === 'function')) : false;
    },
  },

  watch: {
    form_data_detail(val) {
      const listColumns = Object.keys(val[0].columns);

      this.variableOptions = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column) => {
          this.variableOptions.push({
            id: column,
            label: column,
            text: column,
          });
        });
      }

      if (this.formDetail.detail_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.detail_view));
        this.dataSetup.text_1 = data.text_1;
        this.dataSetup.text_2 = data.text_2;
      }

      if (this.formDetail.tabs && this.formDetail.tabs.length > 0) {
        this.tabs = [];
        this.formDetail.tabs.forEach((tab, index) => {
          const componentMaster = [];
          tab.component.forEach((c) => {
            componentMaster.push({
              id: c.id,
              name: c.name,
              info: c.info,
              type: c.type,
              component_master_id: c.component_master_id,
            });
          });
          this.tabs.push({
            id: `id-tab-${index}`,
            title: tab.title,
            component: componentMaster,
          });
        });
        // const tabs = [...this.formDetail.tabs];
        // this.tabs = tabs.map((tab, index) => ({
        //   id: `id-tab-${index}`,
        //   ...tab,
        // }));
        this.tabSelected = this.tabs[0];
        this.tabIndexSelected = 0;
      } else {
        this.tabs = [{ id: `id-tab-${this.tabs.length}`, title: 'Tab 1', component: [] }];
        this.tabSelected = this.tabs[0];
        this.tabIndexSelected = 0;
      }
    },

    list_component_master(data) {
      // eslint-disable-next-line
      const dataMaster = Array.from(Object.create(data)).sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
      const availData = ['form_ui', 'multiple_form_ui'];
      // const availData = ['form_ui'];
      this.dataComponent = dataMaster.filter(e => availData.includes(e.name)).map((v) => {
        const x = v;
        switch (v.name) {
          case 'form_ui':
            x.comp_name = 'single_experience_manager';
            break;
          case 'multiple_form_ui':
            x.comp_name = 'multiple_experience_manager';
            break;
          default :
            x.comp_name = v.name;
        }
        return x;
      });
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.actionGetDetailFormData(param);
      this.isLoading = false;
    } else {
      await this.setExternalUrl();
      this.isLoading = false;
    }

    const parameter = {
      limit: 0,
      page: 1,
      column: 'id',
      sort: 'asc',
      query: '',
      query_type: '',
    };
    this.listComponentMaster({ params: parameter });
  },

  mounted() {
    this.setIsComponent(true);
  },

  beforeDestroy() {
    this.setIsComponent(false);
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailMultiForm', 'actionSetMultiForm', 'actionGetDetailFormData']),
    ...mapActions('jStoreApplication', ['listComponentMaster']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),
    ...mapMutations('jStoreExperienceManagerV2', ['setPropertiesOpened']),

    setExternalUrl() {
      const listColumns = Object.keys(this.formDetail.data_source.external_url.columns);

      this.variableOptions = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column) => {
          this.variableOptions.push({
            id: column,
            label: column,
            text: column,
          });
        });
      }

      if (this.formDetail.detail_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.detail_view));
        this.dataSetup.text_1 = data.text_1;
        this.dataSetup.text_2 = data.text_2;
      }

      if (this.formDetail.tabs && this.formDetail.tabs.length > 0) {
        this.tabs = [];
        this.formDetail.tabs.forEach((tab, index) => {
          const componentMaster = [];
          tab.component.forEach((c) => {
            componentMaster.push({
              id: c.id,
              name: c.name,
              info: c.info,
              type: c.type,
              component_master_id: c.component_master_id,
            });
          });
          this.tabs.push({
            id: `id-tab-${index}`,
            title: tab.title,
            component: componentMaster,
          });
        });
        // const tabs = [...this.formDetail.tabs];
        // this.tabs = tabs.map((tab, index) => ({
        //   id: `id-tab-${index}`,
        //   ...tab,
        // }));
        this.tabSelected = this.tabs[0];
        this.tabIndexSelected = 0;
      } else {
        this.tabs = [{ id: `id-tab-${this.tabs.length}`, title: 'Tab 1', component: [] }];
        this.tabSelected = this.tabs[0];
        this.tabIndexSelected = 0;
      }
    },

    changeTab(tab, index) {
      this.tabSelected = tab;
      this.tabIndexSelected = index;
      this.toggleConfigurationComponent(false);
    },

    openModalFieldLibrary() {
      if (!this.isOpenPropertiesComp) {
        this.setShowModalFieldLibrary(true);

        setTimeout(() => {
          const element = document.getElementById('modalFieldLibrary');
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById('modalFieldLibrary');
      if (element) element.classList.remove('show');

      if (data) {
        const findComponent = this.dataComponent.find(c => c.comp_name === data.type);
        const newData = {
          type: findComponent.name,
          name: data.name,
          component_master_id: findComponent.id,
        };
        const index = this.tabs[this.tabIndexSelected].component.push(newData) - 1;

        this.selectedComponent = newData;
        this.selectedIndexComponent = index;

        setTimeout(() => {
          this.toggleConfigurationComponent(true);
        }, 200);
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
      }, 300);
    },

    openModalTitle(type) {
      if (this.isOpenModalTab) this.toggleModalTab(false);
      const data = type === 'text_1' ? this.dataSetup.text_1 : this.dataSetup.text_2;

      if (this.isOpenModalTitle) {
        this.toggleModalTitle(false);

        setTimeout(() => {
          this.selectedTitle = data;
          this.selectedTypeTitle = type;
          this.toggleModalTitle(true);
        }, 250);
      } else {
        this.selectedTitle = data;
        this.selectedTypeTitle = type;
        this.toggleModalTitle(true);
      }
    },

    toggleModalTitle(status) {
      if (status) {
        this.isOpenModalTitle = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalTitle);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalTitle);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalTitle = false;
          this.selectedTitle = null;
          this.selectedTypeTitle = null;
        }, 200);
      }
    },

    submitModalTitle(data) {
      if (this.selectedTypeTitle === 'text_1') this.dataSetup.text_1 = data;
      else if (this.selectedTypeTitle === 'text_2') this.dataSetup.text_2 = data;
      this.toggleModalTitle(false);
      this.setChangesValueView(true);
    },

    openModalTab(data, index) {
      if (this.isOpenModalTitle) this.toggleModalTitle(false);

      if (this.isOpenModalTab) {
        this.toggleModalTab(false);

        setTimeout(() => {
          this.selectedTab = data ? data.title : null;
          this.selectedIndexTab = index;
          this.toggleModalTab(true);
        }, 250);
      } else {
        this.selectedTab = data ? data.title : null;
        this.selectedIndexTab = index;
        this.toggleModalTab(true);
      }
    },

    toggleModalTab(status) {
      if (status) {
        this.isOpenModalTab = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalTab);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalTab);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalTab = false;
          this.selectedTab = null;
          this.selectedIndexTab = null;
        }, 200);
      }
    },

    submitModalTab(data) {
      if (this.selectedTab) this.tabs[this.selectedIndexTab].title = data;
      else this.tabs.push({ id: `id-tab-${this.tabs.length}`, title: data, component: [] });
      this.toggleModalTab(false);
      this.setChangesValueView(true);
      this.$forceUpdate();
    },

    deleteTab(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this tab?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          this.tabs.splice(index || this.selectedIndexTab, 1);
          if (this.isOpenModalTab) this.toggleModalTab(false);
          if (index || this.selectedIndexTab === this.tabIndexSelected) {
            this.tabSelected = this.tabs[0];
            this.tabIndexSelected = 0;
          }
          this.setChangesValueView(true);
        }
      });
    },

    onOpenNewtab(component) {
      const componentInfo = JSON.parse(component.info);
      let url = '';
      if (component.type === 'form_ui') {
        url = `${window.location.origin}/#/experience-manager/update/${componentInfo.form_ui_id}`;
      }
      if (component.type === 'multiple_form_ui') {
        url = `${window.location.origin}/#/multiple-experience-manager/update/${componentInfo.multiple_form_ui_id}`;
      }
      window.open(url, '_blank');
    },

    openConfigurationComponent(component, index) {
      if (this.isOpenPropertiesComp) {
        setTimeout(() => {
          this.selectedComponent = component;
          this.selectedIndexComponent = index;
          this.toggleConfigurationComponent(true);
        }, 250);
      } else {
        this.selectedComponent = component;
        this.selectedIndexComponent = index;
        this.toggleConfigurationComponent(true);
      }
    },

    toggleConfigurationComponent(status) {
      if (status) {
        this.isOpenPropertiesComp = true;
        this.setPropertiesOpened(true);
        setTimeout(() => {
          const element = document.getElementById(this.idPropertiesComp);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idPropertiesComp);
        if (element) element.classList.remove('show-properties-field');
        this.setPropertiesOpened(false);

        setTimeout(() => {
          this.isOpenPropertiesComp = false;
          this.selectedComponent = null;
          this.selectedIndexComponent = null;
        }, 200);
      }
    },

    deleteComponent(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this component?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          this.tabs[this.tabIndexSelected].component.splice(index || this.selectedIndexComponent, 1);
          if (this.isOpenPropertiesComp) this.toggleConfigurationComponent(false);
          this.setChangesValueView(true);
        }
      });
    },

    submitComponent(params, isCancel) {
      if (params.info && !isCancel) {
        this.tabs[this.tabIndexSelected].component[this.selectedIndexComponent] = params;
      } else if (!params.info && isCancel) {
        this.tabs[this.tabIndexSelected].component.splice(this.selectedIndexComponent, 1);
      }
      if (!isCancel) this.setChangesValueView(true);
      this.toggleConfigurationComponent(false);
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            const res = await this.actionSetMultiForm(this.genData);
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              await this.actionGetDetailMultiForm(param);
            }
          }
        });
      }
    },

    async deleteView() {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          params.detail_view = null;
          params.tabs = [];
          this.tabs = [{ id: `id-tab-${this.tabs.length}`, title: 'Tab 1', component: [] }];
          this.tabSelected = this.tabs[0];
          this.tabIndexSelected = 0;
          this.dataSetup = {
            title: null,
            text_1: null,
            text_2: null,
          };

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },

    modifyData({ added }) {
      if (added) {
        const data = { ...this.tabs[this.tabIndexSelected].component[added.newIndex] };
        const findComponent = this.dataComponent.find(c => c.comp_name === data.type);

        data.type = findComponent.name;
        data.component_master_id = findComponent.id;

        this.tabs[this.tabIndexSelected].component[added.newIndex] = data;
        this.openConfigurationComponent(data, added.newIndex);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jMultipleDetailView.vue